export default "__VITE_ASSET__CpHpL37Y__"